// copied from svetnapojov-2023

import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

const wNumbPrice = wNumb({
    decimals: 0,
    suffix: Eshop.options.currency.symbol_right
})

let $rangeSlider;

function updateRangeCallback(selectors, values, sliderInstance) {
    $(selectors.from).val(values[0]);
    $(selectors.to).val(values[1]);

    Filter.submit();
}

function createPriceRange() {
    const $elem = $('.js-range-price');
    const $slider = $elem.find('.range-slider__slider');
    const maxValue = parseInt($elem.attr('data-max'));
    const minValue = parseInt($elem.attr('data-min'));
    const fromValue = parseInt($elem.attr('data-from'));
    const toValue = parseInt($elem.attr('data-to'));
    const sliderRanges = {};


    if (!$slider.length) {
        return false;
    }

    sliderRanges['min'] = [minValue];

    if (minValue < (50 - 10) && maxValue > (50 + 10)) {
        sliderRanges['40%'] = [50, 10];
    }

    if (minValue < (200 - 50) && maxValue > (200 + 50)) {
        sliderRanges['60%'] = [200, 50];
    }

    if (minValue < (1000 - 100) && maxValue > (1000 + 100)) {
        sliderRanges['80%'] = [1000, 100];
    }

    sliderRanges['max'] = [maxValue];

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: sliderRanges,
        margin: 1,
        connect: true,
        tooltips: [
            wNumbPrice,
            wNumbPrice
        ],
        format: wNumbPrice,
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);
    });

    $('#filter-price-from').on('change', function () {
        const $priceToInput = $('#filter-price-to');
        const min = parseInt($(this).attr('min'));
        const max = parseInt($priceToInput.attr('max'));
        const inputToValue = parseInt($priceToInput.val());
        const hasInputToValue = typeof inputToValue === 'number' && !isNaN(inputToValue)

        let value = $(this).val() == '' ? min : parseInt($(this).val());

        if (value < min) {
            value = min;
        }
        else if (value > inputToValue) {
            value = inputToValue;
        }

        $(this).val(wNumbPrice.to(value));

        if (!hasInputToValue) {
            $priceToInput.val(wNumbPrice.to(max));
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('change', function () {
        const $priceFromInput = $('#filter-price-from');
        const min = parseInt($priceFromInput.attr('min'));
        const max = parseInt($(this).attr('max'));
        const inputFromValue = parseInt($priceFromInput.val());
        const hasInputFromValue = typeof inputFromValue === 'number' && !isNaN(inputFromValue)

        let value = $(this).val() == '' ? max : parseInt($(this).val());

        if (value > max) {
            value = max;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
        }

        $(this).val(wNumbPrice.to(value));

        if (!hasInputFromValue) {
            $priceFromInput.val(wNumbPrice.to(min));
        }

        $rangeSlider.set([null, value]);
    });
}

$(function () {
    if ($('.filter-price').length > 0) {
        createPriceRange();
    }

    $('.js-filter-price-range').on('change', function () {
        const $checkedInput = $('.js-filter-price-range:checked'),
            priceArray = $checkedInput.val().split(';'),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $('#filter-price-from').val(min);
        $('#filter-price-to').val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });

});